import { faSearch } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

function Input({
  id,
  name,
  icon,
  value,
  onChange,
  autoComplete,
  required,
  placeholder,
  step,
  spellCheck,
  type,
  label,
  error,
  min,
  className,
  uppercase,
  autoCapitalize,
  onKeyDown,
  readOnly,
  disabled,
  suffix
}) {
  return (
    <div className={className}>
      <div className={`${suffix || icon ? 'relative' : ''} inputBox flex w-full text-sm tracking-tight space-y-1`}>
        {icon && (
          <FontAwesomeIcon className="my-auto absolute top-4 left-2" icon={icon} />
        )}
        {suffix && (
          <div className="my-auto absolute top-4 right-2">
            {suffix}
          </div>
        )}
        <input
          id={id}
          name={name}
          type={type}
          placeholder=""
          required={required}
          autoComplete={autoComplete}
          autoCapitalize={autoCapitalize}
          spellCheck={spellCheck}
          value={value}
          step={step}
          min={min}
          onChange={onChange}
          onKeyDown={onKeyDown}
          readOnly={readOnly}
          disabled={disabled}
          className={`${uppercase ? 'uppercase' : ''} ${icon ? 'inputBoxWithIcon' : ''} ${suffix ? 'inputBoxWithSuffix' : ''} inputField bg-white disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400 placeholder-gray-400 text-gray-900 text-base rounded-md p-3 w-full appearance-none focus:ring-1 focus:ring-accent border ${error ? 'border-red-500' : 'border-gray-200'} focus:border-accent outline-none focus:outline-none transition ease-in-out duration-500`}
        />
        <span className={`${uppercase ? 'uppercase' : ''} inputLabel text-sm`}>{label}{required && <span className="text-red-500 ml-1">*</span>}</span>
      </div>
      {error && <div className="text-sm ml-2 font-light text-red-500">{error}</div>}
    </div>
  );
}

export default Input;
